module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic12.a6c6566.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic12.png
// module id = 511
// module chunks = 1